import clsx from 'clsx';
import React from 'react';

import IconTIApp from '@components/Images/Rebranding/IconTIApp';
import TIPollsAppIcon from '@components/Images/Rebranding/TIPollsAppIcon';

import FeatureCluster from './FeatureCluster';

interface AppsClusterProps {
  className?: string;
}
const AppsCluster = ({ className }: AppsClusterProps) => {
  return (
    <div className={clsx('flex w-full flex-col lg:flex-row', className)}>
      <FeatureCluster
        className="relative mb-32 border-0 border-b border-solid border-grayscale-gray pb-32 sm:mb-48 sm:pb-48 lg:bottom-auto lg:my-0 lg:border-b-0 lg:border-r lg:pb-0 lg:pr-64"
        description="Stay ahead from anywhere. Our app delivers our latest tech and AI news, analysis and alerts—so you never miss what matters."
        imageElement={<IconTIApp height={80} width={80} />}
        title="The Information App"
      />
      <FeatureCluster
        className="relative mb-0 border-0 border-b-0 border-solid border-grayscale-gray pb-32 sm:pb-48 lg:bottom-auto lg:my-0 lg:mb-48 lg:pb-0 lg:pl-64"
        description="Five questions a day on the biggest stories in tech. Answer, then see what the industry really thinks. Free with your work email, and your answers stay private."
        imageElement={<TIPollsAppIcon height={80} width={80} />}
        title="Polls by The Information"
      />
    </div>
  );
};

export default AppsCluster;
